import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {BatchDetail} from './batch-detail/BatchDetail'
import {BatchListWrapper} from './batch-list/BatchList'

const ScheduledPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/list'
          element={
            <>
              <BatchListWrapper />
            </>
          }
        />
        <Route
          path='/:id/detail'
          element={
            <>
              <BatchDetail />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/scheduled/list' />} />
    </Routes>
  )
}

export default ScheduledPage
